import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faCaretDown, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import logo from '../images/logo.webp';

const Navbar = () => {
  const [isFixed, setIsFixed] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [navHeight, setNavHeight] = useState(0);

  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  // Fix navbar on scroll beyond a certain point
  const handleScroll = () => {
    setIsFixed(window.scrollY > 130);
  };

  // Desktop: show dropdown on hover
  const handleMouseEnter = () => {
    if (window.innerWidth >= 768) {
      setIsDropdownOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth >= 768) {
      setIsDropdownOpen(false);
    }
  };

  // Toggle entire mobile nav
  const toggleMobileNav = () => {
    setMobileNavOpen((prev) => !prev);
    // Optionally reset sub-menu state whenever you open/close
    // setIsDropdownOpen(false);
  };

  // Toggle sub-menu on mobile
  // We prevent navigation to `/leistungen` so user can see sub-items.
  const handleToggleSubMenuMobile = (e) => {
    if (window.innerWidth < 768) {
      e.preventDefault();
      setIsDropdownOpen((prev) => !prev);
    }
  };

  useEffect(() => {
    const navbar = document.querySelector('header');
    if (navbar) {
      setNavHeight(navbar.offsetHeight);
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {/* Top bar */}
      <div className="top-bar">
        <div className="top-bar-content">
          <span><strong>Fragen?</strong></span>
          <FontAwesomeIcon icon={faPhone} />
          <span>+49 6887 894429</span>
          <FontAwesomeIcon icon={faEnvelope} />
          <span>elektro_thome@yahoo.de</span>
        </div>
      </div>
      {/* This spacer keeps layout from jumping when nav becomes fixed */}
      {isFixed && <div style={{ height: `${navHeight}px` }} />}

      <header className={`navbar ${isFixed ? 'nav-fixed' : ''}`}>
        {/* Logo */}
        <Link to="/" className="logo">
          <img src={logo} alt="Logo Elektro Thome" />
        </Link>

        {/* Mobile menu toggle */}
        <button className="mobile-menu-toggle" onClick={toggleMobileNav}>
          <FontAwesomeIcon icon={mobileNavOpen ? faTimes : faBars} />
        </button>

        {/* Nav section */}
        <nav className={mobileNavOpen ? 'mobile-active' : ''}>
          <ul>
            <li>
              <Link
                className={`und nav-links ${isActive('/') ? 'active' : ''}`}
                to="/"
                onClick={() => setMobileNavOpen(false)}
              >
                Home
              </Link>
            </li>

            {/* Dropdown parent */}
            <li
              className="dropdown"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Link
                className={`und nav-links ${isActive('/leistungen') ? 'active' : ''}`}
                to="/leistungen"
                onClick={handleToggleSubMenuMobile}
              >
                Leistungen
                <FontAwesomeIcon className="navbar-icon" icon={faCaretDown} />
              </Link>
              {/* Sub-menu */}
              <ul className={`dropdown-content ${isDropdownOpen ? 'visible' : ''}`}>
                <li>
                  <Link
                    className="dd-link"
                    to="/leistungen/photovoltaik"
                    onClick={() => setMobileNavOpen(false)}
                  >
                    Photovoltaik Anlage
                  </Link>
                </li>
                <li>
                  <Link
                    className="dd-link"
                    to="/leistungen/installation"
                    onClick={() => setMobileNavOpen(false)}
                  >
                    Elektro-installation
                  </Link>
                </li>
                <li>
                  <Link
                    className="dd-link"
                    to="/leistungen/landestation"
                    onClick={() => setMobileNavOpen(false)}
                  >
                    Intelligente Landestation/Wallbox
                  </Link>
                </li>
              </ul>
            </li>

            <li>
              <Link
                className={`und nav-links ${isActive('/contact') ? 'active' : ''}`}
                to="/contact"
                onClick={() => setMobileNavOpen(false)}
              >
                Kontakt
              </Link>
            </li>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Navbar;
